module.exports = __webpack_public_path__ + "img/Row1.d722ef93.png";